import axios from "axios";
import { host, port, path, version } from "../systemVariables";

// Method path
const resource = "/machinegenerations";

export function getAllMachinGenerations(callback) {
  return () => {
    axios
      .get(host + port + path + version + resource, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      })
      .then((response) => {
        callback(response);
      })
      .catch(function (error) {
        return error;
      });
  };
}

/**
 * It's an async function that makes a GET request to an API endpoint and returns the response or
 * error.
 * @returns The response object.
 */
export async function getAllMachineGenerationsAsync() {
  try {
    const response = await axios.get(host + port + path + version + resource, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
      },
    });
    return response;
  } catch (error) {
    return error;
  }
}
